/**
 * @since 0.18.0
 * @visibleName COLOR_SCHEMES
 * @component
 */
export default {
  LIGHT: 'light',
  SHADE: 'shade',
  DARK: 'dark',
} as const;
